module.exports = __webpack_public_path__ + "static/img/product_1_7.80338a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_1_7.png
// module id = NnpR
// module chunks = 34